import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Table } from 'reactstrap';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import Moment from 'moment';
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import {  
   
   allInjuryChart,
   fetchInjuryDetails,
   allSSTeam,
   updateInjuryProfile,
   updateInjuryupdate,
   uploadInjuryReport,
   fetchInjuryReports,
   deleteInjuryReports,
   updateInjuryReport
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';



class injuryprofile extends Component {
   
    constructor(props) {
       
        super(props);
            this.confirmationDialog = React.createRef();
            this.state = {
                viewdiv:true,
                succdiv:false,
                student:'',
                selectedFile:'',
                repttable:true,
            };  
        
        this.selectorRef = React.createRef(null);
        this.onBackSection = this.onBackSection.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
      
    }

    UNSAFE_componentWillMount() {
        this.props.allSSTeam();
        this.props.allInjuryChart();
	}
    
    onFileChange(event){
        const file = event.target.files[0];
        const base64 = this.convertBase64(file).then(result => this.setState({
            selectedFile: result
          }));
       
    };

    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file)
          fileReader.onload = () => {
            resolve(fileReader.result);
          }
          fileReader.onerror = (error) => {
            reject(error);
          }
        })
    }

    addHandleReport(rowid){
        
        this.props.fetchInjuryDetails(rowid).then((data) => { 
            this.props.fetchInjuryReports(rowid);
            this.setState({ 
                maindiv:false,
                viewdiv:false,
                errordiv:false,
                succdiv:true 
            });  

        });
        
    }

    editHandleSubmit(event){
        event.preventDefault();
        this.props.updateInjuryProfile(event);
        
    }
    
    reportHandleSubmit(event){
        event.preventDefault();
        this.setState({ 
            repttable:false
        }); 
        let selectedFile = this.state.selectedFile;
        this.props.uploadInjuryReport(event, selectedFile).then((data) => { 
            this.setState({ 
                repttable:true
            }); 

        });
        
    }

    reportUpdateSubmit(event){
        event.preventDefault();
        this.props.updateInjuryReport(event);
        
    }

    updateProfileSubmit(event){
        event.preventDefault();
        this.props.updateInjuryupdate(event);
    }

    deleteFile(rowid,scid){
        if(window.confirm('Are you sure to delete this report?')){          
            this.props.deleteInjuryReports(rowid,scid);    
         }
        
    }

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	} 
    
    exportPDFWithMethod = () => {
        this.selectorRef.current.save();
    }

    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
    }


    onBackSection() {
		this.setState({ 
            succdiv:false,
            maindiv:true,
            viewdiv:true,
         });
	}

    render() {
        const { match, injurychartlists, injuryfulldetails, injuryallupdates, injuryallfiles, ssteamlists, loading } = this.props;
       
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "date", label: "Date" },
            { name: "report", label: "Report" }
        ];
        const tabledata=injurychartlists.map((assmntval,idx) => {            
            
                const ebtn=<MatButton variant="contained" className="btn-info mr-3 mb-3 text-white" onClick={ ()=>this.addHandleReport(assmntval.sicID)}> <i className="zmdi zmdi-file-text"></i>  View Profile</MatButton>;
             
                return {
                no:idx+1,
                name: assmntval.student,
                date: assmntval.cdate,
                report: ebtn
                }
        });

        
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Injury Profile Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.injuryprofileheading" />} match={match} />

            


                {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-8">
                     <RctCollapsibleCard heading="Injury Profile List" fullBlock>
                        <MUIDataTable                              
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
                } 

                {this.state.succdiv &&
                    <div className="row">
                        <div className="col-sm-12 col-lg-6">
                           <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                            <RctCollapsibleCard heading="Edit Injury Profile">   
                                    <div className="row float-right"> 
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.onBackSection} >Back</button>
                                    </div>                           
                                <div className="row">
                                        
                                    <div className="col-sm-12 col-lg-8"> 
                                        <h3>Name : {injuryfulldetails.student}</h3>   
                                    </div>   
                                    
                                    <div className="col-sm-12 col-lg-8">
                                        <h3>Date : {Moment(injuryfulldetails.sic_date).format('DD-MM-YYYY hh:mm')}</h3>                                         
                                    </div>  
                                    <div className="col-sm-12 col-lg-6 col-xl-6">   
                                        <FormGroup>
                                            <Label for="Select">Assessor Name *</Label>
                                                <select name="teamid" id="teamid" className="form-control form-control-alternative" defaultValue={injuryfulldetails.sic_teamID} required>
                                                    <option value=""></option>
                                                        {ssteamlists.map((teamval) => (   
                                                                teamval.sc_status==1 ?                                                       
                                                                <option value={teamval.sctID}>{teamval.sc_name}</option>  
                                                                :''                                                            
                                                    ))}
                                                </select>
                                        </FormGroup>  
                                    </div>  
                                    <div className="col-sm-12 col-lg-6 col-xl-6">   
                                        <FormGroup>
                                            <Label for="Select">Age *</Label>
                                            <input type="text" name="age" id="age" defaultValue={injuryfulldetails.sic_age} className="form-control form-control-alternative" required/>
                                        </FormGroup>  
                                    </div> 
                                    <div className="col-sm-12 col-lg-6 col-xl-6">   
                                        <FormGroup>
                                            <Label for="Select">Gender *</Label>
                                                <select name="gender" id="gender" defaultValue={injuryfulldetails.sic_gender} className="form-control form-control-alternative" required>
                                                    <option value=""></option>
                                                    <option value="1">Male</option>
                                                    <option value="2">Female</option>                                                          
                                                </select>
                                        </FormGroup>  
                                    </div>
                                                                        
                                    <div className="col-sm-12 col-lg-6 col-xl-6">   
                                        <FormGroup>
                                            <Label for="Select">Skill *</Label>
                                                <select name="skill" id="skill" defaultValue={injuryfulldetails.sic_skill} className="form-control form-control-alternative" required>
                                                    <option value=""></option>
                                                    <option value="Rt Dominant Golfer">Rt Dominant Golfer</option>
                                                    <option value="Lt Dominant Golfer">Lt Dominant Golfer</option>
                                                </select>
                                        </FormGroup>  
                                    </div>    
                                    <div className="col-sm-12 col-lg-6 col-xl-12">
                                        <FormGroup>
                                            <Label for="Select">Chief Complaint</Label>
                                            <textarea rows="4" type="text" name="chief_complaint" defaultValue={injuryfulldetails.sic_chief_complaint} id="chief_complaint" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="Select">Mechanism Of Injury</Label>
                                            <textarea rows="4" type="text" name="mechanism_injury" id="mechanism_injury" defaultValue={injuryfulldetails.sic_mechanism_injury} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup>                                                 
                                        <FormGroup>
                                            <Label for="Select">History of Present Injury</Label>
                                            <textarea rows="4" type="text" name="history_present_injury" id="history_present_injury" defaultValue={injuryfulldetails.sic_history_present_injury} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">History of Similar Injury in the Past</Label>
                                            <textarea rows="4" type="text" name="history_injury_past" id="history_injury_past" defaultValue={injuryfulldetails.sic_history_injury_past}  className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">Clinical Observations and Assessment</Label>
                                            <textarea rows="4" type="text" name="observations_assessment" id="observations_assessment" defaultValue={injuryfulldetails.sic_observations_assessment} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">Clinical Findings</Label>
                                            <textarea rows="4" type="text" name="clinical_findings" id="clinical_findings" defaultValue={injuryfulldetails.sic_clinical_findings} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">Provisional Diagnosis</Label>
                                            <textarea rows="4" type="text" name="provisional_diagnosis" id="provisional_diagnosis" defaultValue={injuryfulldetails.sic_provisional_diagnosis} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">Injury Severity</Label>
                                            <textarea rows="4" type="text" name="injury_severity" id="injury_severity" defaultValue={injuryfulldetails.sic_injury_severity} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">Plan of Action</Label>
                                            <textarea rows="4" type="text" name="plan_action" id="plan_action" defaultValue={injuryfulldetails.sic_plan_action} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        <FormGroup>
                                            <Label for="Select">Expected time for Return to Sports</Label>
                                            <textarea rows="4" type="text" name="return_sports" id="return_sports" defaultValue={injuryfulldetails.sic_return_sports} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                        </FormGroup> 
                                        {/* <FormGroup>
                                            <Label for="Select">Medical Tests/Reports if any</Label>
                                            <input type="file" name="fileupl" id="fileupl" onChange={this.onFileChange} className="form-control form-control-alternative"/>
                                        </FormGroup>   */}
                                    </div>
                                    <div className="form-group">
                                        <input type="hidden" name="eid" id="eid" value={injuryfulldetails.sicID}></input>
                                        <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                        <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                                    </div>                                           
                                </div>
                            </RctCollapsibleCard>  
                            </form>

                            <div>
                            <RctCollapsibleCard heading="Medical Tests/Reports">
                                {this.state.repttable &&  
                                <div className="table-responsive">
                                    <Table hover bordered striped>
                                        <thead>
                                            <tr className="bg-primary text-white">
                                                <th>Sl.No</th>
                                                <th>Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>                              
                                        {injuryallfiles.map((flval,idx) => (
                                            
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td><form autoComplete="off" className="form-horizontal form-validate form-inline" onSubmit={(e)=>this.reportUpdateSubmit(e)}> 
                                                        <input type="text" name="updname" className="form-control form-control-alternative" defaultValue={flval.sir_reportname} key={flval.sir_reportname} />
                                                        <input type="hidden" name="eid" id="eid" value={flval.sirID}></input>
                                                        <input type="submit" className="MuiButtonBase-root MuiButton-root MuiButton-text text-warning mr-3 mb-3" value="update" />
                                                    </form>    
                                                </td>
                                                <td>
                                                <a href={AppConfig.apiurl+'/theme/img/injuryreport/'+flval.sir_filename} target="_blank"><span className="badge badge-info" >View</span></a>
                                                <IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteFile(flval.sirID,flval.sicID)}><DeleteOutlineOutlinedIcon/></IconButton> 
                                                </td>
                                            </tr>
                                        ))}                                                                
                                        </tbody>
                                    </Table>
                                </div>
                                }
                                <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.reportHandleSubmit(e)}> 
                                        <div className="form-group">
                                            <FormGroup>
                                                <Label for="Select">Report Name</Label>
                                                <input type="text" name="reportname" id="reportname" className="form-control form-control-alternative" required/>
                                            </FormGroup>  
                                        </div>
                                        <div className="form-group">
                                        <FormGroup>
                                            <Label for="Select">Upload Medical Tests/Reports</Label>
                                            <input type="file" name="fileupl" id="fileupl" onChange={this.onFileChange} className="form-control form-control-alternative" required/>
                                        </FormGroup>  
                                        </div>
                                        <div className="form-group">
                                            <input type="hidden" name="eid" id="eid" value={injuryfulldetails.sicID}></input>
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                            <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />
                                        </div>                                           
                                </form>
                            </RctCollapsibleCard>    
                            </div>
                        </div>   

                        
                        <div className="col-sm-12 col-lg-6">
                            {injuryallupdates.map((uptval,idx) => ( 
                                <div className="float-left">
                                <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.updateProfileSubmit(e)}>
                                    <RctCollapsibleCard>   
                                            <h1 className="text-center"> Update {idx+1}</h1>                               
                                            <div className="row">
                                                                        
                                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                                                                                
                                                    <FormGroup>
                                                        <Label for="Select">Update on Rehabilitation *</Label>
                                                        <textarea rows="4" type="text" name="update_rehabilitation" defaultValue={uptval.siu_update_rehabilitation} id="update_rehabilitation" required className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Plan Of Action *</Label>
                                                        <textarea rows="4" type="text" name="plan_action" defaultValue={uptval.siu_plan_action} id="plan_action" required className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                                                                
                                                </div>
                                                    <div className="form-group">
                                                        <input type="hidden" name="uid" id="uid" value={uptval.siuID}></input>
                                                        <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                                    </div>
                                                    
                                            </div>
                                    </RctCollapsibleCard> 
                                    
                                </form> 
                                </div>
                            ))}
                        </div>    
                          
                    </div>   

                } 
               
            
          </div>
       )
    }
 }
 
 const mapStateToProps = ({ injurychart, ssteam  }) => {
    
    const { injurychartlists, injuryfulldetails, injuryallupdates, injuryallfiles, loading } = injurychart;
    const { ssteamlists } = ssteam;
	return { injurychartlists, injuryfulldetails, injuryallupdates, injuryallfiles, ssteamlists, loading };
}

export default connect(mapStateToProps, {
   
    allInjuryChart,
    fetchInjuryDetails,
    allSSTeam,
    updateInjuryProfile,
    updateInjuryupdate,
    uploadInjuryReport,
    fetchInjuryReports,
    deleteInjuryReports,
    updateInjuryReport
})(injuryprofile); 